/**
 * Pagination.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 모바일의 페이지네이션을 컨트롤 및 렌더하는 컴포넌트입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import React from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import styled from 'styled-components/macro';

interface Props {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  totalCount: number;
  limit?: number;
}
const Pagination = ({ currentPage, setCurrentPage, totalCount, limit = 10 }: Props) => {
  const endPageNumber = Math.ceil(totalCount / limit);

  const handlePrevButton = () => {
    if (currentPage === 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextButton = () => {
    if (currentPage === endPageNumber) {
      return;
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  return totalCount === 0 ? null : (
    <PaginationContainer>
      <PageItem onClick={handlePrevButton}>
        <FaAngleLeft />
      </PageItem>
      <PageListItem>
        <PageList on={true}>{currentPage}</PageList>
        <PageList on={false}>/ {endPageNumber}</PageList>
      </PageListItem>
      <PageItem onClick={handleNextButton}>
        <FaAngleRight />
      </PageItem>
    </PaginationContainer>
  );
};

export default Pagination;

const PaginationContainer = styled.div`
  text-align: center;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4rem 0;
`;
const PageItem = styled.div`
  display: inline-block;
  font-size: 1rem;
  color: #666;
  background-color: #eee;
  height: 1.875rem;
  width: 1.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  margin: 0 0.6875rem;
  cursor: pointer;
`;

const PageListItem = styled.div`
  display: inline-block;
`;

const PageList = styled.span<{ on: boolean }>`
  display: inline-block;
  margin: 0;
  font-size: 1rem;
  cursor: pointer;
  color: ${props => (props.on ? '#ff671d' : '#666')};
`;
